/**
 * Shared types and utilities for the billing encounters table layout.
 *
 * Layout modes control which columns are visible at different screen widths:
 * - full     (xl, >= 1536px): All columns
 * - standard (lg, 1200-1535px): Same column set as full minus width optimizations
 * - compact  (md, 900-1199px): Drop Provider, Service, CPT/Charges
 * - card     (< 900px): Stacked card layout
 *
 * The "Ready" column (ready-to-bill indicator) is visible on all non-card layouts.
 */

/** Layout mode for the billing encounters table */
export type TableLayoutMode = 'full' | 'standard' | 'compact' | 'card';

/** Shared grid gap value (MUI spacing units) */
export const GRID_GAP = 1.5;

/**
 * Returns the CSS Grid `gridTemplateColumns` value for a given layout mode.
 *
 * Column order by layout:
 *   full:     Icon(32) Date(100) Provider(1fr) Patient(0.9fr) Service(0.8fr) CPT/Charges(170) Note(56) Claim(80) Ready(68) Actions(44)
 *   standard: Icon(32) Date(90)  Provider(1fr) Patient(0.9fr) Service(0.7fr) CPT/Charges(150) Note(56)     Claim(80) Ready(68) Actions(44)
 *   compact:  Icon(32) Date(90)  Patient(0.9fr) Note(56)     Claim(80)  Ready(68px) Actions(44)
 *   card:     Not applicable (returns empty string)
 */
export function getGridTemplateColumns(layout: TableLayoutMode): string {
  switch (layout) {
    case 'full':
      return '32px 100px 1fr 0.9fr 0.8fr 170px 56px 80px 68px 44px';
    case 'standard':
      return '32px 90px 1fr 0.9fr 0.7fr 150px 56px 80px 68px 44px';
    case 'compact':
      return '32px 90px 0.9fr 56px 80px 68px 44px';
    case 'card':
      return '';
  }
}
